module.exports = __webpack_public_path__ + "img/button2.4dbaa4a2.png";